import { post } from "services/http";

type ConversionStep =
  | "PAGE_LOAD"
  | "USER_INFO_ENTERED"
  | "PURCHASE_COMPLETE"
  // For shop page v1
  | "PURCHASE_CLICKED"
  | "PURCHASE_GIFT_CLICKED"
  // For shop page v2
  | "PLAN_GROUP_CLICKED"
  | "PROCEED_TO_USER_INFO"
  // For normal register flow
  | "ADDITIONAL_MEMBERS_INFO_ENTERED";

interface TrackUserActivityRequest {
  userId?: number;
  step: ConversionStep;
  flow: "REGISTER" | "SHOP_PHASE_ONE" | "SHOP_PHASE_TWO";
  currentUrl?: string;
}

const getCurrentUrl = () =>
  typeof window !== "undefined" ? window.location.href : undefined;

export const trackConversion = (params: TrackUserActivityRequest) => {
  let sessionId = localStorage.getItem("session_id");

  if (params.step !== "PURCHASE_COMPLETE" && !sessionId) {
    sessionId = Math.random().toString(36).substring(2, 15);
    localStorage.setItem("session_id", sessionId);
  }
  if (params.step === "PURCHASE_COMPLETE") {
    localStorage.removeItem("session_id");
  }

  if (sessionId) {
    return post({
      url: "/conversion/track",
      params: {
        ...params,
        sessionId,
        currentUrl: params.currentUrl ?? getCurrentUrl(),
      },
    });
  }

  // no-op
  return Promise.resolve();
};
